/*
 * Generated scaffold from split manifest.
 * Source: src/hooks/useQRGenerator.ts
 * Notes: Create helper functions for artwork frame processing.
 */

import type { QRGeneratorConfig } from "@/domain/qr/generator";
import { cloneCanvasFrame } from "./clone-canvas-frame.service";
import type { ArtworkFrameState } from "./frames-artworkstate.types";
import { getQRGenerator } from "../generation/generation-singleton";

export function makeArtworkFrameHelpers(params: {
  artworkState: ArtworkFrameState;
  previewScanConfigBase: QRGeneratorConfig;
  frameOverlayCanvas: HTMLCanvasElement | OffscreenCanvas;
  frameIdx: number;
}): {
  reuseLastSuccessfulFrame: () => HTMLCanvasElement | null;
  rememberSuccessfulFrame: (f: HTMLCanvasElement | OffscreenCanvas, mp: number) => void;
  fallbackGenerate: () => Promise<HTMLCanvasElement | OffscreenCanvas | null>;
} {
  const reuseLastSuccessfulFrame = (): HTMLCanvasElement | null =>
    params.artworkState.lastSuccessfulArtworkFrame
      ? cloneCanvasFrame(params.artworkState.lastSuccessfulArtworkFrame)
      : null;
  const rememberSuccessfulFrame = (
    frame: HTMLCanvasElement | OffscreenCanvas,
    matchPercentage: number,
  ): void => {
    params.artworkState.setLastSuccessfulFrame(
      cloneCanvasFrame(frame, params.artworkState.lastSuccessfulArtworkFrame),
    );
    if (Number.isFinite(matchPercentage)) {
      params.artworkState.setLastSuccessfulMatchPercentage(matchPercentage);
    }
  };
  const fallbackGenerate = () =>
    getQRGenerator().generate(
      {
        ...params.previewScanConfigBase,
        frameIndex: params.frameIdx,
        overlayMode: "dithered",
      },
      params.frameOverlayCanvas,
    );
  return { reuseLastSuccessfulFrame, rememberSuccessfulFrame, fallbackGenerate };
}
